// extracted by mini-css-extract-plugin
export var description = "timeline-module--description--450a8";
export var diamond = "timeline-module--diamond--a6b5c";
export var diamondLine = "timeline-module--diamondLine--34059";
export var imageLine = "timeline-module--imageLine--fa85b";
export var line = "timeline-module--line--f82f3";
export var mobileLine = "timeline-module--mobileLine--1ac3e";
export var mobileTimeLine = "timeline-module--mobileTimeLine--b6f3e";
export var mobileTimelineWrapper = "timeline-module--mobileTimelineWrapper--0f833";
export var root = "timeline-module--root--d6e88";
export var rootHeader = "timeline-module--rootHeader--99166";
export var smallLine = "timeline-module--smallLine--073d8";
export var stat = "timeline-module--stat--b1602";
export var statDescription = "timeline-module--statDescription--a9a8a";
export var statTitle = "timeline-module--statTitle--9170b";
export var statsWrapper = "timeline-module--statsWrapper--fccaa";
export var timeline = "timeline-module--timeline--0cd59";
export var timelineData = "timeline-module--timelineData--dd169";
export var timelineDataTop = "timeline-module--timelineDataTop--11580";
export var timelineEvent = "timeline-module--timelineEvent--be1bb";
export var timelineImage = "timeline-module--timelineImage--79834";
export var title = "timeline-module--title--b103e";
export var year = "timeline-module--year--841d3";